export const FORCED_PERIOD_TOLERANCE_FACTOR = 0.2;

export const EMPTY_GAP_SET: ReadonlySet<number> = new Set<number>();

export const insertGaps = (
	data: [number, number | null][],
	forcedPeriodMs: number | undefined,
	gapAt?: ReadonlySet<number>,
): [number, number | null][] => {
	if (!forcedPeriodMs || forcedPeriodMs <= 0 || data.length < 2) {
		return data;
	}

	const threshold = forcedPeriodMs * (1 + FORCED_PERIOD_TOLERANCE_FACTOR);
	const result: [number, number | null][] = [data[0]];

	for (let i = 1; i < data.length; i++) {
		const prevTime = data[i - 1][0];
		const time = data[i][0];
		const holeBefore = gapAt ? gapAt.has(time) : true;

		if (holeBefore && time - prevTime > threshold) {
			result.push([prevTime + 1, null]);
		}

		result.push(data[i]);
	}

	return result;
};

export const findIsolatedPoints = (
	data: [number, number | null][],
): [number, number | null][] =>
	data.filter(
		(point, i) =>
			point[1] != null &&
			(i === 0 || data[i - 1][1] == null) &&
			(i === data.length - 1 || data[i + 1][1] == null),
	);
